// Theme: night-market
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'night-market',
  name: 'NIGHT MARKET',
  tagline: 'NIGHT MARKET',
  description: 'Lanterna de papel e especiarias com brilho intimo noturno.',
  category: 'urban-expression',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#1A0F08', '#2A1A10', '#FB923C', '#FFF7ED'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-sans theme-night-market'
  },
  colorVars: {
    '--accent': '#FB923C',
    '--accent-foreground': '#1A0F08',
    '--background': '#1A0F08',
    '--border': '#8A5020',
    '--card': '#2A1A10',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FFF7ED',
    '--card-glow': 'color-mix(in srgb, var(--primary) 8%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A0F08',
    '--foreground': '#FFF7ED',
    '--hold-fill': '#FB923C',
    '--input': '#8A5020',
    '--modal-bg': '#1A0F08',
    '--modal-border': '#8A5020',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#8A5020',
    '--muted-foreground': '#FFF7ED',
    '--nav-active': '#FB923C',
    '--nav-bg': '#2A1A10',
    '--popover': '#2A1A10',
    '--popover-foreground': '#FFF7ED',
    '--primary': '#FB923C',
    '--primary-foreground': '#1A0F08',
    '--ring': '#FB923C',
    '--secondary': '#8A5020',
    '--secondary-foreground': '#FFF7ED',
    '--streak': '#FB923C',
    '--success': '#22c55e',
    '--success-foreground': '#1A0F08',
    '--xp': '#FB923C',
    '--xp-bg': '#2A1A10'
  },
  resolvedVars: {
    '--accent': '#FB923C',
    '--accent-foreground': '#1A0F08',
    '--accent-foreground-hsl': '23 53% 7%',
    '--accent-foreground-oklch': 'from #1A0F08 l c h',
    '--accent-hsl': '27 96% 61%',
    '--accent-oklch': 'from #FB923C l c h',
    '--background': '#1A0F08',
    '--background-hsl': '23 53% 7%',
    '--background-oklch': 'from #1A0F08 l c h',
    '--border': '#8A5020',
    '--border-hsl': '27 62% 33%',
    '--border-oklch': 'from #8A5020 l c h',
    '--border-w': '1px',
    '--card': '#2A1A10',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FFF7ED',
    '--card-foreground-hsl': '33 100% 96%',
    '--card-foreground-oklch': 'from #FFF7ED l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 8%, transparent)',
    '--card-hsl': '23 45% 11%',
    '--card-oklch': 'from #2A1A10 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A0F08',
    '--destructive-foreground-hsl': '23 53% 7%',
    '--destructive-foreground-oklch': 'from #1A0F08 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FFF7ED',
    '--foreground-hsl': '33 100% 96%',
    '--foreground-oklch': 'from #FFF7ED l c h',
    '--hold-fill': '#FB923C',
    '--hold-fill-hsl': '27 96% 61%',
    '--hold-fill-oklch': 'from #FB923C l c h',
    '--input': '#8A5020',
    '--input-hsl': '27 62% 33%',
    '--input-oklch': 'from #8A5020 l c h',
    '--modal-bg': '#1A0F08',
    '--modal-bg-hsl': '23 53% 7%',
    '--modal-bg-oklch': 'from #1A0F08 l c h',
    '--modal-border': '#8A5020',
    '--modal-border-hsl': '27 62% 33%',
    '--modal-border-oklch': 'from #8A5020 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#8A5020',
    '--muted-foreground': '#FFF7ED',
    '--muted-foreground-hsl': '33 100% 96%',
    '--muted-foreground-oklch': 'from #FFF7ED l c h',
    '--muted-hsl': '27 62% 33%',
    '--muted-oklch': 'from #8A5020 l c h',
    '--nav-active': '#FB923C',
    '--nav-active-hsl': '27 96% 61%',
    '--nav-active-oklch': 'from #FB923C l c h',
    '--nav-bg': '#2A1A10',
    '--nav-bg-hsl': '23 45% 11%',
    '--nav-bg-oklch': 'from #2A1A10 l c h',
    '--popover': '#2A1A10',
    '--popover-foreground': '#FFF7ED',
    '--popover-foreground-hsl': '33 100% 96%',
    '--popover-foreground-oklch': 'from #FFF7ED l c h',
    '--popover-hsl': '23 45% 11%',
    '--popover-oklch': 'from #2A1A10 l c h',
    '--primary': '#FB923C',
    '--primary-foreground': '#1A0F08',
    '--primary-foreground-hsl': '23 53% 7%',
    '--primary-foreground-oklch': 'from #1A0F08 l c h',
    '--primary-hsl': '27 96% 61%',
    '--primary-oklch': 'from #FB923C l c h',
    '--radius': '10px',
    '--ring': '#FB923C',
    '--ring-hsl': '27 96% 61%',
    '--ring-oklch': 'from #FB923C l c h',
    '--secondary': '#8A5020',
    '--secondary-foreground': '#FFF7ED',
    '--secondary-foreground-hsl': '33 100% 96%',
    '--secondary-foreground-oklch': 'from #FFF7ED l c h',
    '--secondary-hsl': '27 62% 33%',
    '--secondary-oklch': 'from #8A5020 l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#FB923C',
    '--streak-hsl': '27 96% 61%',
    '--streak-oklch': 'from #FB923C l c h',
    '--success': '#22c55e',
    '--success-foreground': '#1A0F08',
    '--success-foreground-hsl': '23 53% 7%',
    '--success-foreground-oklch': 'from #1A0F08 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(27 96% 61% / 0.15)',
    '--xp': '#FB923C',
    '--xp-bg': '#2A1A10',
    '--xp-bg-hsl': '23 45% 11%',
    '--xp-bg-oklch': 'from #2A1A10 l c h',
    '--xp-hsl': '27 96% 61%',
    '--xp-oklch': 'from #FB923C l c h'
  }
}
